// useIsMobile — tracks whether the viewport is at or below the app's mobile
// breakpoint, live (not just at mount), so a layout can react to a resize or
// orientation change without a page reload. Same breakpoint and matchMedia
// approach as useResponsivePageSize.ts's NARROW query, extracted here because
// a second caller (HomeRailLayout, [mobile-rail-fix]) needed the identical
// check for something other than pagination.
import { useEffect, useState } from "react";

const MOBILE = "(max-width: 767.98px)"; // matches home.css's rail-stacking breakpoint

// matchMedia is absent in some environments (e.g. jsdom under test); treat
// "unknown" as the desktop (wider) case.
function mobileNow(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(MOBILE).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(mobileNow);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia(MOBILE);
    const update = (): void => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
}
